<template>
  <div class="energyCostAnalysis-wrap">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span class="headerTitle">任务器配置</span>
        <div class="tobbox">
          <div class="tobboxItem">
            <label class="sum">开始时间</label>
            <el-date-picker
              style="width: 250px"
              v-model="startTime"
              type="date"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy/MM/dd HH:mm:ss"
              placeholder="选择日期"
            ></el-date-picker>
          </div>
          <div class="tobboxItem">
            <label class="sum">结束时间</label>
            <el-date-picker
              style="width: 250px"
              v-model="endTime"
              type="date"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy/MM/dd HH:mm:ss"
              placeholder="选择日期"
            ></el-date-picker>
          </div>
        </div>
      </div>
      <div slot="header" class="clearfix">
        <span class="headerTitle">用能成本分析报告参数配置</span>
      </div>
      <div style="display: flex; margin-bottom: 22px">
        <label class="sum">报告名称</label>
        <el-input
          clearable
          placeholder="请输入报告名称"
          v-model="baseName"
        ></el-input>
      </div>
      <el-form
        ref="form"
        :model="formObject"
        label-width="120px"
        label-position="right"
      >
        <el-form-item label="项目公司名称">
          <el-input
            v-model="formObject.projectName"
            placeholder="请输入项目公司名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="电压等级">
          <el-input v-model="formObject.voltageGrade"></el-input>
        </el-form-item>
        <el-form-item label="进线路数">
          <el-input
            clearable
            placeholder="请输入进线路数"
            v-model="formObject.intoTheLineNumber"
          ></el-input>
        </el-form-item>
        <el-form-item label="运行方式">
          <el-input
            clearable
            placeholder="请输入运行方式"
            v-model="formObject.measurementMethods"
          ></el-input>
        </el-form-item>
        <el-form-item label="变压器数量">
          <el-input-number
            class="input180"
            v-model="formObject.transformerNumber"
            :min="1"
            label="请输入变压器数量"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="用电类型">
          <el-input
            clearable
            placeholder="请输入用电类型"
            v-model="formObject.electricityType"
          ></el-input>
        </el-form-item>
        <el-form-item label="基本电费类型">
          <el-input
            clearable
            placeholder="请输入基本电费类型"
            v-model="formObject.basicElectricityType"
          ></el-input>
        </el-form-item>
        <template v-for="(type, typeIndex) in types">
          <div :key="typeIndex">
            <p class="form-info el-form-item">{{ type.typeInfo }}</p>
            <el-form-item :label="`用${type.typeName}量总点`">
              <label class="point-name">{{
                formObject[type.type]["measureName"]
              }}</label>
              <label class="btn-point" @click="selectPoint(type.type)"
                >选择测量点</label
              >
            </el-form-item>
            <el-form-item :label="`${type.typeName}量编号`">
              <el-input
                clearable
                :placeholder="`请输入${type.typeName}量编号`"
                v-model="formObject[type.type]['pointNumber']"
              ></el-input>
            </el-form-item>
            <el-form-item
              :label="typeItem.type"
              v-for="(typeItem, index) in type.items"
              :key="'typeItem' + index"
            >
              <el-button
                style="float: left; margin-bottom: 10px"
                type="primary"
                @click="
                  addTypeClick(
                    typeItem,
                    type.typeName,
                    formObject[type.type][typeItem.prop],
                  )
                "
                >新增{{ typeItem.addType }}</el-button
              >
              <el-table
                :data="formObject[type.type][typeItem.prop]"
                border
                style="width: 100%; margin-top: 15px"
              >
                <el-table-column
                  type="index"
                  :index="1"
                  label="序号"
                  width="80"
                ></el-table-column>
                <template v-for="(formItem, index) in tableColumn">
                  <el-table-column
                    :key="index"
                    :prop="formItem.prop"
                    :label="typeItem.addType + formItem.label"
                    :min-width="formItem.width"
                  ></el-table-column>
                </template>
                <el-table-column
                  prop="measureIdList"
                  label="计量点集合"
                  min-width="180"
                >
                  <template slot-scope="scope">
                    <span
                      v-for="(measureIdItem, index) in scope.row.measureIdList"
                      :key="measureIdItem"
                    >
                      {{
                        index != scope.row.measureIdList.length - 1
                          ? measureIdItem + "，"
                          : measureIdItem
                      }}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column fixed="right" label="操作" width="90">
                  <template slot-scope="scope">
                    <el-button
                      type="text"
                      size="small"
                      @click="
                        editItem(
                          scope.$index,
                          typeItem,
                          type.typeName,
                          formObject[type.type][typeItem.prop]
                        )
                      "
                      >编辑</el-button
                    >
                    <el-button
                      type="text"
                      size="small"
                      @click="
                        removeItem(
                          scope.$index,
                          formObject[type.type][typeItem.prop]
                        )
                      "
                      >移除</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>
          </div>
        </template>
        <div>
          <el-button type="primary" @click="savePageAllData"
            >立即保存</el-button
          >
          <el-button @click="resetForm">重置</el-button>
        </div>
      </el-form>
    </el-card>
    <!-- 选择测量点 -->
    <el-dialog
      title="请选择树节点"
      :visible.sync="selectNodeDialog"
      custom-class="dialog"
      :close-on-click-modal="false"
    >
      <div class="dialog-info">
        <div class="view-tree">
          <div
            :class="[
              'view-tree-item',
              index === viewTreeIndex ? 'view-tree-select' : '',
            ]"
            v-for="(item, index) in viewTree"
            :key="index"
            @click="viewTreeClick(item, index)"
          >
            {{ item.displayName }}
          </div>
        </div>
        <div class="dialog-box" style="width: 100%; height: 300px">
          <nk-left-tree
            ref="tree"
            :defaultCurrent="false"
            :data="leftTreeData"
            v-if="leftTreeData.length > 0"
            @click="nodeClick"
          ></nk-left-tree>
        </div>
      </div>
      <!-- <span slot="footer" class="dialog-footer" v-show="isShowModal">
                <el-button @click="selectNodeDialog = false">取 消</el-button>
                <el-button type="primary" @click="selectNodeEnter">确 定</el-button>
            </span> -->
    </el-dialog>
    <el-dialog
      :title="modeltitle"
      :visible.sync="isShowModal"
      center
      width="35%"
      :close-on-click-modal="false"
    >
      <el-form
        label-position="right"
        ref="childrenObjectFrom"
        :model="childrenObject"
        label-width="120px"
        :rules="modelRules"
        :show-message="false"
      >
        <el-form-item :label="`${childrenObject.label}名称`" prop="name">
          <el-input
            clearable
            :placeholder="`请输入${childrenObject.label}名称`"
            v-model="childrenObject.name"
          ></el-input>
        </el-form-item>
        <el-form-item :label="`${childrenObject.label}容量`">
          <el-input
            clearable
            :placeholder="`请输入${childrenObject.label}容量`"
            v-model="childrenObject.capacity"
          ></el-input>
        </el-form-item>
        <el-form-item label="计量点集合" prop="measureIdList">
          <!-- <el-input clearable placeholder="多个计量点用英文逗号隔开" v-model="childrenObject.measureIdList"></el-input> -->
          <!-- <label class="point-name">{{childrenObject.measureName}}</label> -->
          <el-tag
            style="margin-right: 6px"
            :key="tag"
            v-for="tag in childrenObject.measureName"
            closable
            :disable-transitions="false"
            @close="handleClose(tag)"
          >
            {{ tag }}
          </el-tag>
          <label class="btn-point" @click="selectPoint('type', 'diglog')"
            >选择测量点</label
          >
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeModel">取 消</el-button>
        <el-button type="primary" @click="addNewTableRow">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as utils from "@/utils/index.js";
import NkLeftTree from "./NkLeftTree.vue";
export default {
  components: { NkLeftTree },
  props: {
    reportData: {
      type: Object,
      default: () => ({}),
    },
  },
  name: "energyCostAnalysis",
  data() {
    return {
      dynamicTags: [
        "标签一",
        "标签二",
        "标签三",
        "标签一1",
        "标签二2",
        "标签三33",
        "标签一5",
        "标签二5",
        "标签三5",
      ],
      baseName: "",
      startTime: "",
      endTime: "",
      formObject: {
        // 项目公司名称
        projectName: "",
        // 电压等级
        voltageGrade: "",
        // 进线路数
        intoTheLineNumber: "",
        // 计量方式
        measurementMethods: "",
        // 运行方式
        runWay: "",
        // 变压器数量
        transformerNumber: 8,
        // 用电类型
        electricityType: "",
        // 基本电费类型
        basicElectricityType: "",
        // 用于算电成本参数
        electricity: {
          // 该报告用电量总点
          measureId: "",
          // 电量编号，解决水跟蒸汽编码一样但编号不一样问题
          pointNumber: 0,
          // 子级变压器集合，几台变压器则几个元素
          childrenTransformerList: [],
          // 部门集合，有几个部门则几个元素
          departmentList: [],
          // 分项集合
          classificationList: [],
        },
        // 用于水相关计算参数，描述同电
        water: {
          measureId: 10000000085,
          pointNumber: 0,
          departmentList: [],
        },
        // 用于蒸汽相关计算参数，描述同电
        steam: {
          measureId: 10000000086,
          pointNumber: 1,
          departmentList: [],
        },
      },
      types: [
        {
          type: "electricity",
          typeInfo: "以下参数用于算电成本",
          typeName: "电",
          items: [
            {
              type: "子级变压器列表",
              prop: "childrenTransformerList",
              addType: "变压器",
            },
            {
              type: "部门列表",
              prop: "departmentList",
              addType: "部门",
            },
            {
              type: "分项列表",
              prop: "classificationList",
              addType: "分项",
            },
          ],
        },
        {
          type: "water",
          typeInfo: "以下参数用于算水成本",
          typeName: "水",
          items: [
            {
              type: "部门列表",
              prop: "departmentList",
              addType: "部门",
            },
          ],
        },
        {
          type: "steam",
          typeInfo: "以下参数用于算蒸汽成本",
          typeName: "蒸汽",
          items: [
            {
              type: "部门列表",
              prop: "departmentList",
              addType: "部门",
            },
          ],
        },
      ],
      tableColumn: [
        {
          prop: "name",
          label: "名称",
          width: 180,
        },
        {
          prop: "capacity",
          label: "容量",
          width: 180,
        },
      ],
      isShowModal: false, //弹窗状态
      modeltitle: "", //弹窗标题
      childrenObject: {
        label: "",
        name: "",
        capacity: "",
        measureIdList: "",
        measureName: "",
      }, //弹窗内容
      addItemData: [], //当前添加的项
      modelRules: {
        //弹窗的表单验证功能
        name: [
          {
            required: true,
            message: "请输入名称",
            trigger: "blur",
          },
        ],
        measureIdList: [
          {
            required: true,
            message: "请输入计量点集合",
            trigger: "blur",
          },
        ],
      },
      editItemIndex: 0,
      isAdd: true, //是否是新增
      selectNodeDialog: false,
      viewTreeIndex: 0,
      viewTree: [],
      leftTreeData: [],
      type: null,
      param: null,
      isViewTreeData: true, //是否可以进行请求下次的视图树数据
    };
  },
  watch: {
    reportData: {
      handler(newVal, oldVal) {
        this.formObject = JSON.parse(newVal.params);
        if (!this.formObject.electricity) {
          this.formObject["electricity"] = {
              // 该报告用电量总点
                measureId: "",
                // 电量编号，解决水跟蒸汽编码一样但编号不一样问题
                pointNumber: 0,
                // 子级变压器集合，几台变压器则几个元素
                childrenTransformerList: [],
                // 部门集合，有几个部门则几个元素
                departmentList: [],
                // 分项集合
                classificationList: [],
          };
        }
        if (!this.formObject.water) {
          this.formObject["water"] = {
              measureId: 10000000085,
                pointNumber: 0,
                departmentList: [],};
            }
        if (!this.formObject.steam) {
          this.formObject["steam"] = {
              measureId: 10000000086,
                pointNumber: 1,
                departmentList: [],
          };
        }
        this.baseName = newVal.baseName;
        this.startTime = newVal.startTime;
        this.endTime = newVal.endTime;
      },
      deep: true,
    },
  },
  mounted() {
    this.resizeChildrenObject();
  },
  methods: {
    resizeChildrenObject() {
      //设置弹窗的默认值
      this.childrenObject.name = ""; //名称
      this.childrenObject.capacity = ""; //容量
      this.childrenObject.measureIdList = ""; //计量点集合
    },
    addTypeClick(typeItem, typeName, data) {
      //点击新增类型按钮时
      this.isAdd = true; //切换为新增状态
      this.modeltitle = "新增" + typeItem.addType + `(${typeName})`; //设置弹窗标题
      this.childrenObject.label = typeItem.addType; //设置新增类型名称
      this.addItemData = data?data:[]; //保存当前要添加的项
      this.childrenObject.name = "";
      this.childrenObject.capacity = "";
      this.childrenObject.measureIdList = [];
      this.childrenObject.measureName = [];
      this.isShowModal = true;
    },
    addNewTableRow() {
      //弹窗点击确定
      let flag = true;
      this.$refs.childrenObjectFrom.validate((valid) => {
        if (!valid) {
          this.$message({
            showClose: true,
            message: "请完善表单信息",
            type: "error",
          });
          flag = false;
        }
      });
      if (!flag) {
        return;
      }
      let addItemData = JSON.parse(JSON.stringify(this.addItemData));
      if (this.isAdd) {
        //新增状态
        this.addItemData.push({
          //添加对应的项
          name: this.childrenObject.name,
          capacity:
            this.childrenObject.capacity === ""
              ? null
              : this.childrenObject.capacity,
          measureIdList: this.childrenObject.measureIdList,
          measureName: this.childrenObject.measureName,
        });
      } else {
        //编辑
        this.$set(this.addItemData, "name", this.childrenObject.name);
        this.$set(
          this.addItemData,
          "capacity",
          this.childrenObject.capacity === ""
            ? null
            : this.childrenObject.capacity
        );
        this.$set(
          this.addItemData,
          "measureIdList",
          this.childrenObject.measureIdList
        );
        this.$set(
          this.addItemData,
          "measureName",
          this.childrenObject.measureName
        );
      }
      this.isShowModal = false;
      this.resizeChildrenObject(); //弹窗关闭重置数据
    },
    closeModel() {
      //关闭弹窗
      this.$refs.childrenObjectFrom.clearValidate();
      this.$refs.childrenObjectFrom.resetFields();
      this.isShowModal = false;
      this.resizeChildrenObject(); //弹窗关闭重置数据
    },
    editItem(index, typeItem, typeName, data) {
      //修改某一项,index:索引，typeItem:数据某一项，typeName:数据类型，data:表格数据源
      this.isAdd = false; //切换为编辑状态
      this.editItemIndex = index;
      this.modeltitle = "编辑" + typeItem.addType + `(${typeName})`; //设置弹窗标题
      let addItemDataNew = JSON.parse(JSON.stringify(data[index]));
      this.addItemData = data[index];
      this.childrenObject = {
        label: typeItem.addType,
        name: this.addItemData.name,
        capacity: this.addItemData.capacity,
        measureIdList:
          addItemDataNew.measureIdList instanceof Array
            ? addItemDataNew.measureIdList
            : [],
        measureName:
          addItemDataNew.measureName instanceof Array
            ? addItemDataNew.measureName
            : [],
      };
      this.isShowModal = true;
    },
    removeItem(index, data) {
      //删除某一项,index:索引，data:表格数据源
      this.$confirm("此操作将永久删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          data.splice(index, 1);
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    async savePageAllData() {
      //点击立即保存
      let vm = this;

      let res = await vm.$api.nhtj.modifyReportAutomaticGeneratingConfig(
        vm.$store.state.user.currentCompanyId,
        vm.reportData.model,
        vm.reportData.id,
        vm.baseName,
        JSON.stringify(vm.formObject),
        vm.reportData.loopRegulation,
        vm.startTime,
        vm.endTime,
        vm.reportData.groupId
      );
      if (res.success) {
        vm.$message.success(res.msg);
        vm.$emit("savePageAllData", true);
      }
    },
    resetForm() {
      //点击重置
      this.$confirm("此操作将丢失已输入的数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.formObject = {
            projectName: "",
            voltageGrade: 1,
            intoTheLineNumber: "",
            measurementMethods: "",
            transformerNumber: 1,
            runWay: "",
            electricityType: "",
            basicElectricityType: "",
            electricity: {
              measureId: "",
              pointNumber: "",
              childrenTransformerList: [],
              departmentList: [],
              classificationList: [],
            },
            water: {
              measureId: "",
              pointNumber: "",
              departmentList: [],
            },
            steam: {
              measureId: "",
              pointNumber: "",
              departmentList: [],
            },
          };
          this.$message({
            type: "success",
            message: "重置成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消重置",
          });
        });
    },
    //树加载
    async bindGetTreeTabCode() {
      let vm = this;
      let res = await vm.$api.view.getCompanyViewTreesInfo(
        this.$store.state.user.info.companyId
      );
      if (res.success) {
        vm.viewTree = res.data;
        vm.viewTreeClick(res.data[0], 0);
      }
    },
    /* 选择计量点 */
    selectPoint(type, param) {
      this.type = type;
      this.param = param;
      this.selectNodeDialog = true;
      this.bindGetTreeTabCode();
    },
    /* 选择视图节点 */
    async viewTreeClick(item, index) {
      let vm = this;
      if (!vm.isViewTreeData) {
        return;
      }
      vm.viewTreeIndex = index;
      vm.isViewTreeData = false; //避免不断点击，造成疯狂请求
      let result = await vm.$api.view.getViewTreeNodes(item.id);
      vm.isViewTreeData = true;
      if (!result.success) {
        vm.$message.error(result.msg);
        return;
      }
      vm.leftTreeData = utils.creatTreeData(result.data, 0);
    },
    /* 视图树节点点击事件 */
    nodeClick(data) {
      //节点点击
      let vm = this;
      if (vm.param == "diglog") {
        let index = vm.childrenObject.measureIdList.findIndex(
          (c) => c == data.id
        );
        if (index == -1) {
          vm.childrenObject.measureIdList.push(data.id);
          vm.childrenObject.measureName.push(data.label);
        }
      } else {
        vm.formObject[vm.type]["measureName"] = data.label;
        vm.formObject[vm.type]["measureId"] = data.id;
      }
      vm.selectNodeDialog = false;
    },
    /* 移除标签 */
    handleClose(tag) {
      this.childrenObject.measureIdList.splice(
        this.childrenObject.measureName.indexOf(tag),
        1
      );
      this.childrenObject.measureName.splice(
        this.childrenObject.measureName.indexOf(tag),
        1
      );
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-form-item__content {
  text-align: left;
}
.energyCostAnalysis-wrap {
  width: 100%;
  height: 100%;
  overflow: auto;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  .box-card {
    .clearfix {
      .headerTitle {
        font-size: 22px;
      }
    }
    .form-info {
      text-align: left;
      font-weight: bold;
      color: #f56c6c;
    }
  }
}
.sum {
  text-align: right;
  vertical-align: middle;
  float: left;
  font-size: 14px;
  color: #606266;
  line-height: 40px;
  padding: 0 12px 0 0;
  box-sizing: border-box;
  width: 120px;
}
.dialog-info {
  display: flex;
  width: 100%;
  height: 300px;
  border: 1px solid #d5dadd;
  .view-tree {
    width: 200px;
    height: 300px;
    border-right: 1px solid #d5dadd;
    overflow-y: auto;
    .view-tree-item {
      line-height: 28px;
      padding: 0 5px;
      box-sizing: border-box;
      border-bottom: 1px dashed #d5dadd;
      cursor: pointer;
      font-size: 14px;
    }
    .view-tree-select {
      background: #d5dadd;
    }
  }
  .dialog-box {
    flex: 1;
    overflow-y: auto;
    padding: 0 5px;
    box-sizing: border-box;
    .tree-warp {
      height: 100%;
    }
  }
}
.btn-point {
  color: #409eff;
  cursor: pointer;
  margin-left: 6px;
}
.bm-item {
  color: #000;
}
.view-tree-select {
  background: #d5dadd;
}
.tobbox {
  padding: 10px;
  box-sizing: border-box;
  .tobboxItem {
    display: flex;
    margin-bottom: 22px;
  }
}
</style>